import axios from "axios"
import { setupInterceptorsTo } from "../Componentes/API/AxiosBuilder"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import IconButton from "@mui/material/IconButton"
import DownloadIcon from "@mui/icons-material/Download"
import { useBody } from "../Body/state/BodyContext"
import { URL_API_SIA } from "../Contantes/Constantes"
import Tooltip from "@mui/material/Tooltip"
import Typography from "@mui/material/Typography"

export default function ArchivoItem({ key, filename, icon, titulo, descripcion, indexItem }) {
  const axiosInstance = setupInterceptorsTo(axios.create())
  const { setMessage, setLoadingBackdrop } = useBody()

  const descargarArchivo = () => {
    setLoadingBackdrop(true)
    axiosInstance({
      method: "GET",
      url: `${URL_API_SIA}/sec_administrativa/` + filename,
      responseType: "blob",
    })
      .then((response) => {
        setLoadingBackdrop(false)
        const url = window.URL.createObjectURL(response.data)
        const a = document.createElement("a")
        a.style.display = "none"
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      })
      .catch((e) => {
        setLoadingBackdrop(false)
        setMessage("Hubo un error al querer descargar el archivo")
      })
  }

  return (
    <ListItemButton
      key={key}
      sx={{
        pl: 4,
        bgcolor: indexItem % 2 === 1 ? "transparent" : "rgba(50, 0, 0, 0.1)",
      }}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText
        primary={titulo}
        secondary={
          <Typography
            component="span"
            variant="body2"
            sx={{ color: "text.primary", display: "inline" }}
          >
            {descripcion}
          </Typography>
        }
      />
      <Tooltip title={"Descargar Archivo"}>
        <IconButton onClick={descargarArchivo}>
          <DownloadIcon color="primary" />
        </IconButton>
      </Tooltip>
    </ListItemButton>
  )
}
